import { logError } from "@src/appV2/lib/analytics";

interface WorkerCredentialMessageData {
  hasExistingCredentials: boolean;
}

/**
 * Parse worker credential message to determine if the worker has existing credentials.
 * The message JSON contains { hasExistingCredentials: boolean }.
 */
export function parseWorkerCredentialMessage(message: string): WorkerCredentialMessageData {
  const defaultData: WorkerCredentialMessageData = {
    hasExistingCredentials: false,
  };

  try {
    const parsed = JSON.parse(message) as { hasExistingCredentials?: boolean };

    return {
      hasExistingCredentials: parsed.hasExistingCredentials ?? false,
    };
  } catch (error) {
    logError("Failed to parse worker credential requested message", {
      error,
      metadata: { message },
    });
    return defaultData;
  }
}
